import { useState } from 'react';
import { useDestroyResolution886Report } from '@/hooks/v2/resolution-886';
import type { Resolution886ItemList } from '@/types/Resolution886';

export function useDeleteModal() {
	const [report, setReport] = useState<Resolution886ItemList | null>(null);
	const [isOpenDeleteModal, setIsOpenDeleteModal] = useState<boolean>(false);
	const { isLoading: isLoadingDeleteModal, mutateAsync: deleleReport } = useDestroyResolution886Report();

	function handleOpenDeleteModal(value: Resolution886ItemList): void {
		setReport(value);
		setIsOpenDeleteModal(true);
	}

	function handleCloseDeleteModal(): void {
		setIsOpenDeleteModal(false);
		setReport(null);
	}

	async function handleOnConfirmDeleteModal(): Promise<void> {
		await deleleReport({
			id: report?.id!,
			company_id: report?.company_id!,
			organization_id: report?.organization_id!
		});
		handleCloseDeleteModal();
	}

	return {
		selectedReport: report,
		isOpenDeleteModal,
		isLoadingDeleteModal,
		handleOpenDeleteModal,
		handleCloseDeleteModal,
		handleOnConfirmDeleteModal
	};
}
